export default ({ hotspot }) => {
  const imageContainerWidth = 350;
  const imageContainerHeight = 200;
  const iconMargin = 25;
  const deltaY = imageContainerHeight / 2 - hotspot.top;
  const imageY = deltaY - iconMargin;

  const deltaX = imageContainerWidth / 2 - hotspot.left;
  const imageX = deltaX - iconMargin;
  return { imageY, imageX };
};
